import { render, staticRenderFns } from "./PostulacionNacionalExport.vue?vue&type=template&id=635402de"
import script from "./PostulacionNacionalExport.vue?vue&type=script&lang=js"
export * from "./PostulacionNacionalExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports